import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Typography, Button, SurfaceColor, Card } from "@carrotfertility/carotene-core"

type BenefitsEnrollmentExpiredProps = {
  onClickEnroll: () => void
  color?: SurfaceColor
}
const BenefitsEnrollmentExpired = ({ onClickEnroll, color = "green" }: BenefitsEnrollmentExpiredProps): JSX.Element => {
  const intl = useIntl()
  return (
    <Card
      variant="secondary"
      color={color}
      title={intl.formatMessage({ defaultMessage: "To access your funds, update your insurance info" })}
      primaryAction={
        <Button variant="outlined" color="secondary" onClick={onClickEnroll}>
          <FormattedMessage defaultMessage="Update plan info" />
        </Button>
      }
    >
      <Typography variant="body1" color="text.secondary">
        <FormattedMessage defaultMessage="Your insurance plan information has expired. Update now to get access to your Carrot funds." />
      </Typography>
    </Card>
  )
}
export default BenefitsEnrollmentExpired
